module.exports = __webpack_public_path__ + "5244143025b2bd26ed41680beee86e47.svg";